import { isAfter, isBefore, parseISO } from 'date-fns';

export const isWithinDateRangeUTC = (
  dateToCompare: number | Date,
  startUtcString: string,
  endUtcString: string,
) => {
  if (!startUtcString || !endUtcString || !dateToCompare) return false;

  const startUtc = parseISO(startUtcString);
  const endUtc = parseISO(endUtcString);

  const hasStarted = isBefore(startUtc, dateToCompare);
  const hasEnded = isAfter(dateToCompare, endUtc);

  return hasStarted && !hasEnded;
};
